import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';
import { get } from 'lodash-es';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';
import EditInfos from './EditInfos';
import { configPersonalInfos } from '../config';

const BlockPersonalInfos = ({ party, strings, i18n, updatePartyPerson, mode, setViewMode, id }) => {
  const { fields, initialValues } = configPersonalInfos({ party, strings });

  const contentViewBlock = (
    <div className="content" key={id}>
      <ItemField label={strings['party.edit.field.code.label'] || 'Code'} value={party.code} />

      <div className="group">
        <ItemField
          label={strings['party.edit.field.gender.label'] || 'Gender'}
          value={party.gender.prefix}
          name="gender"
          optional
        />
        <ItemField
          label={strings['party.edit.field.first_name.label'] || 'First Name'}
          value={party.firstName}
          name="firstName"
          optional
        />
        {/* Not yet supported by Coog API */}
        <ItemField
          label={strings['party.edit.field.birth_name.label'] || 'Birth Name'}
          value={party.birthName}
          name="birthName"
          optional
        />
        <ItemField label={strings['party.edit.field.name.label'] || 'Name'} value={party.name} name="name" optional />
      </div>
      <div className="group">
        <ItemField
          label={strings['party.edit.field.birth_date.label'] || 'Birth Date'}
          value={party.birthDate}
          name="birthDate"
          type="date"
          optional
          i18n={i18n}
        />
        {/* Not yet supported by Coog API */}
        <ItemField
          label={strings['party.edit.field.birth_order.label'] || 'Birth Order'}
          value={party.birthOrder}
          name="birthOrder"
          optional
        />
      </div>
    </div>
  );

  const contentEditBlock = (
    <div className="content" key={`personal-informations-${id}`}>
      <EditInfos
        id={party.id}
        initialValues={initialValues}
        fields={fields}
        updateParty={updatePartyPerson}
        setViewMode={setViewMode}
        buttonSubmitLabel={strings['party.edit.block.button.submit.label'] || 'Enregistrer les modifications'}
        locale={get(i18n, 'lang', 'fr')}
      />
    </div>
  );

  return mode === 'view' ? <>{contentViewBlock}</> : <>{contentEditBlock}</>;
};

BlockPersonalInfos.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  genders: PropTypes.object,
  updatePartyPerson: PropTypes.func,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired, // HOC withToggleView
  setViewMode: PropTypes.func.isRequired, // HOC withToggleView,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockPersonalInfos.defaultProps = {
  party: {},
  strings: {},
  i18n: fromJS({}),
  genders: fromJS({}),
  // eslint-disable-next-line no-console
  updatePartyPerson: (...params) => console.log('updatePartyPerson', ...params),
};

const config = {
  title: 'party.edit.block.personal-informations.label',
  defaultTitle: 'Personal Informations',
  name: 'personal-informations',
};

export default withToggleView(BlockPersonalInfos, config);
